import React from 'react'

import facebook from './../../../UI/canvas/Social/facebook.svg'
import twitter from './../../../UI/canvas/Social/twitter.svg'
import youtube from './../../../UI/canvas/Social/youtube.svg'
import instagram from './../../../UI/canvas/Social/instagram.svg'

interface Props{}

interface State{}

declare const window: any;

class Social extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className='social-media-main'>
                <div className='social-text-container'>
                    Síguenos
                </div>
                <div className='icons-social-container'>
                    <div 
                        className='individual-social-container'
                        onClick = {
                            () => {
                                window.paramsObj = {
                                    "section-menus": "REDES SOCIALES"+">"+"FACEBOOK",
                                            };
                                window.ym(88905571, "params", window.paramsObj || {})
                            }
                        }
                    >
                        <a className='' href="https://www.facebook.com/fordcolombia" target="_blank">
                            <img src={facebook}></img>
                        </a>
                    </div>
                    <div 
                        className='individual-social-container'
                        onClick = {
                            () => {
                                window.paramsObj = {
                                    "section-menus": "REDES SOCIALES"+">"+"TWITTER",
                                            };
                                window.ym(88905571, "params", window.paramsObj || {})
                            }
                        }
                    >
                        <a className='' href="https://twitter.com/FordColombia" target="_blank">
                            <img src={twitter}></img>
                        </a>
                    </div>
                    <div 
                        className='individual-social-container'
                        onClick = {
                            () => {
                                window.paramsObj = {
                                    "section-menus": "REDES SOCIALES"+">"+"YOUTUBE",
                                            };
                                window.ym(88905571, "params", window.paramsObj || {})
                            }
                        }
                    >
                        <a className='' href="https://www.youtube.com/channel/UCem33C2WfZEM_cAZtW7Tt6w" target="_blank">
                            <img src={youtube}></img>
                        </a>
                    </div>
                    <div 
                        className='individual-social-container'
                        onClick = {
                            () => {
                                window.paramsObj = {
                                    "section-menus": "REDES SOCIALES"+">"+"INSTAGRAM",
                                            };
                                window.ym(88905571, "params", window.paramsObj || {})
                            }
                        }
                    >
                        <a className='' href="https://www.instagram.com/fordcolombia/" target="_blank">
                            <img src={instagram}></img>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Social 